<script setup>
import {computed} from 'vue';

import CommonMenuBar from "@/Components/account/CommonMenuBar.vue";
import {route} from "ziggy-js";
import {useI18n} from "vue-i18n";
const t = useI18n().t

const props = defineProps({
    title: String,
    product: Object,
});


const items = computed(() => [
    {
        label: t('menu.documentation'),
        href: route('public.documentation'),
    },
    {
        label: 'Dashboard',
        href: route('admin.login.view'),
    }
]);

</script>

<template>
    <div class="w-auto">
        <CommonMenuBar :items="items"/>
        <main class="col-12">
            <slot/>
        </main>
    </div>
</template>

